import serverErrorMessages from "../translations/serverErrorMessages";
import removeFieldName from "./removeFieldName";

const selectErrorMessage = data => {
  let errorObj;

  if (data instanceof Error && data.response) {
    errorObj = data.response;
  } else {
    errorObj = data;
  }

  let msg = "Hiba történt";

  if (errorObj) {
    if (errorObj.message) {
      msg = errorObj.message;
    }
  }

  return removeFieldName(msg);
};

const selectErrorTranslation = errorString => serverErrorMessages[errorString];

export const selectErrorNotificationMessage = data => {
  const errorString = selectErrorMessage(data);
  const errorTranslation = selectErrorTranslation(errorString);

  return {
    text: errorString,
    translation: errorTranslation
  };
};

export default selectErrorMessage;

